import React from "react";
import { withARMA } from "@utils/ARMA";

type AnchorProps = JSX.IntrinsicElements["a"];

const Anchor: React.FC<AnchorProps> = props => {
  // eslint-disable-next-line local-rules/no-native-a
  return <a {...props} />;
};

export const AccAnchor = withARMA(Anchor);

export type AccAnchorProps = React.ComponentProps<typeof AccAnchor>;
